module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.displayError) ? _c('p', {
    staticClass: "error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.displayError))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.customerInfo.id) ? _c('section', [_c('h1', [_vm._v(_vm._s(_vm.human_readable_name(_vm.customerInfo)))]), _vm._v(" "), (_vm.customerInfo.statutar) ? _c('div', [_vm._v("statutární orgán: " + _vm._s(_vm.customerInfo.statutar))]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          Klientské číslo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v("\n          " + _vm._s(_vm.customerInfo.id) + "\n          "), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "grey-note"
    }
  }, [_vm._v("slouží zároveň jako variabilní symbol pro platby")])])]), _vm._v(" "), (_vm.customerInfo.ten) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          IČO\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v("\n          " + _vm._s(_vm.customerInfo.ten) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.customerInfo.regon) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          DIČ\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v("\n          " + _vm._s(_vm.customerInfo.regon) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          Telefon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, _vm._l((_vm.customerInfo.phoneNumbers), function(pn) {
    return _c('div', {
      key: pn.phone
    }, [_vm._v("\n            " + _vm._s(pn.phone) + "\n            "), (pn.typ_sml == 0 || pn.typ_tech == 0) ? _c('span', [(pn.typ_sml) ? _c('span', [_vm._v("✆ smluvní")]) : _vm._e(), _vm._v(" "), (pn.typ_tech) ? _c('span', [_vm._v("✆ technický")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (pn.name) ? _c('span', [_vm._v(" (" + _vm._s(pn.name) + ")")]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          E-mail\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, _vm._l((_vm.customerInfo.emailAddresses), function(e) {
    return _c('div', {
      key: e.email
    }, [_vm._v("\n            " + _vm._s(e.email) + "\n            "), (e.typ_sml == 0 || e.typ_f == 0 || e.typ_tech == 0 || e.typ_sam == 0) ? _c('span', [(e.typ_sml) ? _c('span', [_vm._v("📧 smluvní")]) : _vm._e(), _vm._v(" "), (e.typ_f) ? _c('span', [_vm._v("📧 fakturační")]) : _vm._e(), _vm._v(" "), (e.typ_tech) ? _c('span', [_vm._v("📧 technický")]) : _vm._e(), _vm._v(" "), (e.typ_sam) ? _c('span', [_vm._v("📧 přístup do samoobsluhy")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (e.note) ? _c('span', [_vm._v(" (" + _vm._s(e.note) + ")")]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [(_vm.customerInfo.type == 1) ? _c('span', [_vm._v("Sídlo")]) : _c('span', [_vm._v("Trvalé bydliště")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', [_vm._v(_vm._s(_vm.customerInfo.address))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.customerInfo.zip) + " " + _vm._s(_vm.customerInfo.city))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.country_name(_vm.customerInfo.countryid)))])])]), _vm._v(" "), (_vm.customerInfo.post_address) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          Doručovací adresa\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.customerInfo.post_name) ? _c('div', [_vm._v(_vm._s(_vm.customerInfo.post_name))]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.customerInfo.post_address))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.customerInfo.post_zip) + " " + _vm._s(_vm.customerInfo.post_city))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.country_name(_vm.customerInfo.post_countryid)))])])]) : _vm._e(), _vm._v(" "), (_vm.customerInfo.inv_address) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          Fakturační adresa\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.customerInfo.inv_name) ? _c('div', [_vm._v(_vm._s(_vm.customerInfo.inv_name))]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.customerInfo.inv_address))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.customerInfo.inv_zip) + " " + _vm._s(_vm.customerInfo.inv_city))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.country_name(_vm.customerInfo.inv_countryid)))])])]) : _vm._e(), _vm._v(" "), (_vm.customerInfo.bank1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          Číslo účtu\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v("\n          " + _vm._s(_vm.customerInfo.bank1) + "\n          "), (_vm.customerInfo.bank2) ? _c('span', [_vm._v(" / " + _vm._s(_vm.customerInfo.bank2))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.customerInfo.oku_list && _vm.customerInfo.oku_list.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n          Ověřovací kód účastníka\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.showFullOKU) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.OKUclicked()
      }
    }
  }, [_c('span', {
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.customerInfo.oku_list[0].oku.substr(0, 3)))]), _vm._v(" ... "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("zobrazit")])]) : _c('div', _vm._l((_vm.customerInfo.oku_list), function(oku) {
    return _c('div', {
      key: oku.oku
    }, [_c('span', {
      staticClass: "monospace"
    }, [_vm._v(_vm._s(oku.oku))]), _vm._v(" "), (_vm.customerInfo.oku_list.length > 1) ? _c('span', [_vm._v("pro " + _vm._s(oku.service_name))]) : _vm._e()])
  }))])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f4ac2e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalDetails.vue
// module id = 305
// module chunks = 1 2